/** Consultores comerciais — integração com a API. */

import apiClient from './apiClient';
import type { Consultor, DadosDoConsultor } from '../types/consultant';

export * from '../types/consultant';

export const consultantService = {
  async listar(): Promise<Consultor[]> {
    const { data } = await apiClient.get<Consultor[]>('/consultores');
    return data ?? [];
  },

  async porId(id: number): Promise<Consultor> {
    const { data } = await apiClient.get<Consultor>(`/consultores/${id}`);
    if (!data) throw new Error('Consultor não encontrado');
    return data;
  },

  async criar(dados: DadosDoConsultor): Promise<Consultor> {
    const { data } = await apiClient.post<Consultor>('/consultores', dados);
    if (!data) throw new Error('Resposta vazia do servidor ao cadastrar o consultor');
    return data;
  },

  async atualizar(id: number, dados: DadosDoConsultor): Promise<Consultor> {
    const { data } = await apiClient.put<Consultor>(`/consultores/${id}`, dados);
    if (!data) throw new Error('Resposta vazia do servidor ao salvar o consultor');
    return data;
  },

  async remover(id: number): Promise<void> {
    await apiClient.delete(`/consultores/${id}`);
  },
};

export default consultantService;
